import { render } from "./AddBookmarks.vue?vue&type=template&id=441c7398&scoped=true"
import script from "./AddBookmarks.vue?vue&type=script&lang=js"
export * from "./AddBookmarks.vue?vue&type=script&lang=js"

import "./AddBookmarks.vue?vue&type=style&index=0&id=441c7398&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\EDZ\\Desktop\\emulator\\linux_app_emulator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-441c7398"]])

export default __exports__